module.exports = __webpack_public_path__ + "dfca715198afe6f165cabc5155b583a0.svg";